export enum HELP_AND_SUPPORT {
    EMAIL = "info@nubi.city",
}